import React, { FC } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import {
    companyNameFull,
    preferedName,
    dataPortalTitle,
} from '../../assets/i18n/i18n'

import { appConfig as appConfigData } from '../../assets/customizations/config'
import ExternalLink from '../../components/ExternalLink'
import PageTitle from '../../components/PageTitle'

type AvailableAppsConfig = {
    [key: string]: boolean | string | Array<any> | null | undefined;  // index signature for dynamic properties
    available_apps_link?: string | null;
}

const availableAppsConfig: AvailableAppsConfig = appConfigData

// add properties for each app
const appProperties = [
    {
        name: 'Flexpa',
        link: 'https://my.flexpa.com/',
        key: 'available_apps_flexpa'
    },
]

const AvailableApps: FC = () => {
    // find available_apps_ 
    const availableAppKeys = Object.keys(availableAppsConfig)
        .filter(key => key.startsWith('available_apps_') && availableAppsConfig[key] === true)

    // filter app properties based on available keys
    const availableAppProperties = appProperties.filter(app => availableAppKeys.includes(app.key))

    // override links if provided
    const availableAppsLink = availableAppsConfig.available_apps_link ?? null

    return (
        <section className='content'>
            <Container>
                <PageTitle displayName="Available Apps" />
                <h1 className='headerText h2'>Available Apps</h1>
                <p>A Member&apos;s account with the {preferedName} {dataPortalTitle} can be used with the following apps at this time. {companyNameFull} will appear when searching in these apps.</p>

                <p>
                    <>All apps approved for use with the {preferedName} {dataPortalTitle} have attested to the <a href='https://www.carinalliance.com/code-of-conduct' target='_blank' rel="noreferrer">Carin Code of Conduct</a>. It is important to know that once an external app is authorized, that app has its own level of security and may not be HIPAA-compliant. Review the terms of use of any external app prior to granting access. Only grant access to trusted apps. To reduce potential exposure, limit the number of external apps that are used.</>
                    {!availableAppsLink ? (
                        <> For additional information, please see the <a href='/help'>Help</a> page.</>
                    ) : null}
                </p>
                <p>
                    {!availableAppsLink ? (
                        <>If a Member would like to use an external app not shown on the list, please <a href="/help#ContactUs">Contact Us</a>.</>
                    ) : null}
                </p>

                {availableAppsLink ? (
                    <a
                        href={availableAppsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="fw-bold h4"
                    >
                        View List of Available Apps
                    </a>
                ) : (
                    availableAppKeys.length === 0 ? (
                        <div className='calloutContainer text-center'>
                            <h2 className='fw-bold h4'>No apps currently available</h2>
                            <p className='mb-0'>To request a new app, please contact us using the information the <a href='/help'>Help</a> page.</p>
                        </div>
                    ) : (
                        availableAppProperties.map((app, index) => (
                            <div className='calloutContainer' key={index}>
                                <Row className='align-items-center'>
                                    <Col sm={4}>
                                        <h2 className='mb-0 fw-bold h4'>{app.name}</h2>
                                    </Col>
                                    <Col sm={4}>
                                        <ExternalLink url={app.link} />
                                    </Col>
                                    <Col sm={4}>
                                        <p className='mb-0 h4'>
                                            Available
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        ))
                    )
                )}
            </Container>
        </section>
    )
}

export default AvailableApps
